import { useEffect, useState } from "react";
import { Envelope, ChatCircle, CheckCircle, XCircle, Clock } from "@phosphor-icons/react";
import api from "../../lib/api";

export default function TrainerNotifications() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    (async () => {
      try { setLogs((await api.get("/notifications")).data); } catch (_e) {}
    })();
  }, []);

  return (
    <div className="space-y-8" data-testid="trainer-notifications">
      <div>
        <div className="tracker text-brand mb-3">[ Comms Log ]</div>
        <h1 className="font-display text-4xl sm:text-5xl">Notifications.</h1>
        <p className="text-zinc-400 mt-2">Every text & email sent from your account.</p>
      </div>

      <div className="card-flat">
        {logs.length === 0 ? (
          <div className="p-16 text-center text-zinc-500 tracker">No notifications sent yet</div>
        ) : (
          <div>
            {logs.map((n) => (
              <div key={n.id} className="px-6 py-4 border-b border-white/5 last:border-b-0 grid grid-cols-12 gap-4 items-center hover:bg-[#1A1A1A]" data-testid={`notification-row-${n.id}`}>
                <div className="col-span-1 text-brand">
                  {n.channel === "email" ? <Envelope size={20} weight="duotone" /> : <ChatCircle size={20} weight="duotone" />}
                </div>
                <div className="col-span-3">
                  <div className="font-semibold text-sm">{n.recipient?.name || "—"}</div>
                  <div className="font-mono text-xs text-zinc-500">{n.channel === "email" ? n.recipient?.email : n.recipient?.phone || "—"}</div>
                </div>
                <div className="col-span-5">
                  <div className="text-sm font-semibold">{n.subject}</div>
                  <div className="text-xs text-zinc-500 line-clamp-1">{n.body_preview?.replace(/<[^>]+>/g, " ").slice(0, 100)}</div>
                </div>
                <div className="col-span-2"><StatusBadge status={n.status} /></div>
                <div className="col-span-1 tracker text-right">{new Date(n.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function StatusBadge({ status }) {
  const map = {
    sent: { icon: <CheckCircle size={14} weight="fill" />, cls: "text-emerald-400 border-emerald-500/30" },
    simulated: { icon: <Clock size={14} weight="fill" />, cls: "text-amber-400 border-amber-500/30" },
    failed: { icon: <XCircle size={14} weight="fill" />, cls: "text-[#FF6B61] border-[#FF3B30]/30" },
  };
  const s = map[status] || map.simulated;
  return (
    <span className={`tracker px-2 py-1 border inline-flex items-center gap-1 ${s.cls}`}>
      {s.icon} {status}
    </span>
  );
}
